import { openTab } from '../components/Helpers'
import { ComponentToolKeys } from 'shared/ui'
import { MasterManagementTools } from '../components/MasterManagement'

export function goToMasterUpdateValidation({ treeId }: { treeId: string }) {
  const params = new URLSearchParams([
    [
      ComponentToolKeys.masterManagement,
      MasterManagementTools.updateValidation,
    ],
  ])
  openTab(`/masters/${treeId}?${params.toString()}`)
}

export function goToTreeManagementTool({
  treeId,
  toolId,
  versionId,
}: {
  treeId: string
  versionId: string
  toolId: string
}) {
  const params = new URLSearchParams([['tMgmt', toolId]])
  openTab(`/tree_management/${treeId}:${versionId}?${params.toString()}`)
}
